<template>
    <div>
        <div class="container container-small py-4">
            <Heading class="py-4" :title="$t('reset_password_title')" :routeName="'vignette'"></Heading>
            <template v-if="!message">
                <Username v-model="email" @unlock-btn="disableButton = false" :title="$t('label_email')" :errorMsg="errorMsgs.email" @input="updateEmail($event)"></Username>
                <button class="btn btn-purple w-100" @click="reset()">{{ $t('btn_reset_password') }}</button>
            </template>
            <template v-if="message">
                <div class="alert alert-success">
                    {{message}}
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import Username from './../snippets/Username.vue'

export default {
    name: 'ResetPassword',
    components: {
         Heading,
         Username
    },
    props: {
    },
    data: function() {
        return {
            email: '',
            loading: false,
            message: '',

            errorMsgs: {
                email: '',
            },
            disableButton: true
        }
    },
    methods: {

        updateEmail(event) {
            this.email = event.value;
        },

        reset() {

            if(this.disableButton) {
                return false;
            }

            if(!this.email) {

                this.errorMsgs.email = this.$t('mandatory');
                return false;
            }

            this.loading = true;

            this.$axios.post('reset-password', {'email': this.email}).then(response => {
                this.message = response.data.message;
                this.loading = false;
            }).catch(err => {
                this.$dialog.alert({
                    'message': err.response.data.error.error_msg,
                    'confirmButtonText': this.$t('btn_i_understand')
                });
                this.loading = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>

input[type=checkbox] {
    margin-top: 15px;
}

p {
    margin-bottom: 0;
    margin-top:15px;
}



$lightgrey: lightgrey;
$green: #59af54;

</style>
